import { JSX } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import WindowService from '@src/services/window.service';

import { StaticLandingPage } from '@src/pages/landing/components/page';
import { useAnalytics } from '@src/hooks/use-analytics.hook';

export function ConnectedStaticLandingPage(): JSX.Element {
  const { trackClick, trackImpression } = useAnalytics();

  /**
   * @constant defaultPetRoute | support of PGUF and thirdparty CMS injection,
   * the backend is handling re-routes based on the feature flag for guest user
   * flow and pets.
   */
  const defaultPetRoute = `${WindowService.base}/guest/pets/new`;

  return (
    <ErrorBoundary FallbackComponent={() => <></>}>
      <StaticLandingPage
        onSectionView={(
          label: string,
          value: string,
          extraData: Record<string, unknown>,
        ) => {
          trackImpression({
            eventLabel: label,
            eventValue: value,
            extraData,
          });
        }}
        onLinkClicked={(
          label: string,
          value: string,
          extraData: Record<string, unknown>,
        ) => {
          trackClick({
            eventLabel: label,
            eventValue: value,
            extraData,
          });
        }}
        onFetchPlansClicked={(label: string, value: string) => {
          trackClick({
            eventLabel: label,
            eventValue: value,
          });
          WindowService.redirectTo(defaultPetRoute);
        }}
      />
    </ErrorBoundary>
  );
}
